module.exports = __webpack_public_path__ + "img/footer-2.c555d11d.gif";